import type { SVGProps } from 'react';
import React from 'react';

export const OpenNewTabIcon:React.FC<SVGProps<SVGSVGElement>> = ({
  width = 18,
  height = 18,
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      {...{ width, height, ...props }}
    >
      <path
        d="M16.8284 0.0449219H12.9901C12.3844 0.0449219 11.8934 0.535862 11.8934 1.14159C11.8934 1.74731 12.3844 2.23825 12.9901 2.23825H14.1854L8.3786 8.0451C7.94542 8.47279 7.94542 9.16369 8.3786 9.59139C8.59245 9.80524 8.8721 9.91491
         9.15175 9.91491C9.4314 9.91491 9.71105 9.80524 9.9249 9.59139L15.7317 3.78455V4.97992C15.7317 5.58564 16.2227 6.07658 16.8284 6.07658C17.4341 6.07658 17.9251 5.58564 17.9251 4.97992V1.14159C17.9251 0.535862 17.4341 0.0449219
          16.8284 0.0449219Z"
      />
      <path
        d="M16.8279 7.72158C16.2222 7.72158 15.7312 8.21252 15.7312 8.81824V15.3982H2.57126V2.23825H9.15125C9.75698 2.23825 10.2479 1.74731 10.2479 1.14159C10.2479 0.535862 9.75698 0.0449219 9.15125 0.0449219H1.47459C0.86887 0.0449219
         0.37793 0.535862 0.37793 1.14159V16.4949C0.37793 17.1006 0.86887 17.5916 1.47459 17.5916H16.8279C17.4336 17.5916 17.9246 17.1006 17.9246 16.4949V8.81824C17.9246 8.21252 17.4336 7.72158 16.8279 7.72158Z"
      />
    </svg>
  );
};